import { render, staticRenderFns } from "./SetupNotificationsHelper.vue?vue&type=template&id=9cd97ef4&scoped=true"
import script from "./SetupNotificationsHelper.vue?vue&type=script&lang=js"
export * from "./SetupNotificationsHelper.vue?vue&type=script&lang=js"
import style0 from "./SetupNotificationsHelper.vue?vue&type=style&index=0&id=9cd97ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd97ef4",
  null
  
)

export default component.exports